import type { ExtendedItemDto } from '@mimir/common/dto/extendedItemDto';
import type { LoadedItem } from '@mimir/common/dto/searchResultHit';
import type { ItemArtefact } from '@mimir/common/dto/transferRequestDtos';

export const urlResolvableItemKeys = <const>['aaf', 'editProxyUrl', 'hasEditProxy', 'highRes', 'proxy'];
export type UrlResolvableItem = Pick<ExtendedItemDto, typeof urlResolvableItemKeys[number]>;

export function resolveTransferUrl(item: UrlResolvableItem, artefact: ItemArtefact): string | null {
  let downloadUrl: string | null | undefined;
  switch (artefact) {
    case 'highres':
      downloadUrl = item.highRes;
      break;

    case 'proxy':
      downloadUrl = item.hasEditProxy ? item.editProxyUrl : item.proxy;
      break;

    case 'aaf':
      downloadUrl = item.aaf;
      break;
  }
  return downloadUrl ?? null;
}

export function canTransferArtefact(item: UrlResolvableItem, artefact: ItemArtefact): boolean {
  return resolveTransferUrl(item, artefact) != null;
}

export async function fetchTransferUrl(
  itemId: string,
  artefact: ItemArtefact,
  api: {
    getItemFields: <K extends keyof LoadedItem>(itemId: string, fields: K[]) => Promise<Pick<LoadedItem, K>>,
  }
): Promise<string | null> {
  switch (artefact) {
    case 'highres':
      const { highRes } = await api.getItemFields(itemId, ['highRes']);
      return highRes ?? null;

    case 'proxy':
      const item = await api.getItemFields(itemId, ['proxy', 'editProxyUrl']);
      const downloadUrl = item.editProxyUrl ?? item.proxy;
      return downloadUrl ?? null;

    case 'aaf':
      const { aaf } = await api.getItemFields(itemId, ['aaf']);
      return aaf ?? null;
  }
}
